import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

/**
 * Custom RouteReuseStrategy that forces the ChecklistComponent to reload
 * every time the route params change, ensuring all data is fresh.
 */
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // No-op
  }

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // For checklist routes, only reuse if both the route config AND all params are identical
    // This ensures that navigating to a different checklist id will reload the component
    if (future.routeConfig === curr.routeConfig) {
      // Check if this is a checklist/receiptform route by looking at the path
      const path = future.routeConfig?.path || '';
      if (path.includes('/s/:id') || path.includes('/mt/:id')) {
        // For checklist routes, check if the id param changed
        const futureId = future.params['id'];
        const currId = curr.params['id'];
        const futureObjectId = future.params['objectid'];
        const currObjectId = curr.params['objectid'];

        // Only reuse if both id and objectid are the same
        return futureId === currId && futureObjectId === currObjectId;
      }
      // For other routes, use default behavior (reuse if same route config)
      return true;
    }
    return false;
  }
}

